<template>
  <span v-if="messageSource" class="message-source-chip" :class="chipClass">
    {{ displayLabel }}
  </span>
</template>

<script>
export default {
  name: 'MessageSourceChip',
  props: {
    messageSource: {
      type: String,
      default: ''
    }
  },
  computed: {
    chipClass() {
      if (this.messageSource === 'sms') {
        return 'chip-sms';
      } else if (this.messageSource === 'email') {
        return 'chip-email';
      } else {
        return 'chip-in-app';
      }
    },
    displayLabel() {
      if (this.messageSource === 'sms') {
        return 'SMS';
      } else if (this.messageSource === 'email') {
        return 'Email';
      } else {
        return 'In-App';
      }
    }
  }
};
</script>

<style scoped>
.message-source-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #374957;
  white-space: nowrap;
}

.chip-in-app {
  background-color: #D6E7FA;
}

.chip-sms {
  background-color: #F8FFFB;
}

.chip-email {
  background-color: #F0E6FC;
}
</style>
